import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var XHRHeaders =
/*#__PURE__*/
function () {
  function XHRHeaders(headerText) {
    _classCallCheck(this, XHRHeaders);

    this._headers = {};

    this._init(headerText);
  }

  _createClass(XHRHeaders, [{
    key: "_init",
    value: function _init(headerText) {
      if (headerText) {
        var headerPairs = headerText.split("\r\n");
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = headerPairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var headerPair = _step.value;
            // Can't use split() here because it does the wrong thing
            // if the header value has the string ": " in it.
            var index = headerPair.indexOf(": ");

            if (index > 0) {
              var key = headerPair.substring(0, index).toLowerCase();
              var val = headerPair.substring(index + 2);
              this._headers[key] = val;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._headers[key.toLowerCase()] || null;
    }
  }, {
    key: "has",
    value: function has(key) {
      return this._headers.hasOwnProperty(key.toLowerCase());
    }
  }]);

  return XHRHeaders;
}();